import { Model } from '@vuex-orm/core'
import Extra from '@/models/Extra'
import { getFromObject } from '@/lang'
import { LangedItem } from './common/commons'

export default class Theme extends Model {
  declare id: string
  declare name?: LangedItem[]
  declare extras: Extra[]
  declare descriptions: any // todo?
  declare internalName: string

  static entity = 'theme'

  static fields() {
    return {
      id: this.attr(null),
      name: this.attr(null).nullable(),
      extras: this.hasMany(Extra, 'currentThemes', 'id'),
      descriptions: this.attr({}),
      internalName: this.string(null)
    }
  }

  get langedName() {
    const name = this.name
    return (name && name.length && name[0].value) || ''
  }

  get realName() {
    return this.name != null
      ? this.name
      : getFromObject(this.descriptions, 'name', 'langCode')
  }

  static fetch() {
    return this.api().get('dataBank/v2/property/themes?languagecode=en?[pa')
  }
}
